module.exports = __webpack_public_path__ + "product_add_favourites-d76a1b688cee9992f7723dc7ffbbb606.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/common/onboarding/product_add_favourites.png
// module id = 1184
// module chunks = 2 3 4 5 6